import React, { useState } from "react";
import api from "../../../../api/client";
import AssetModal, { Field } from "./AssetModal";
import { WARRANTY_TYPES, errorMessage, toInputDate } from "./assetUtils";

export default function WarrantyModal({ machineId, warranty, onClose, onSaved }) {
  const editing = Boolean(warranty);
  const [form, setForm] = useState({
    warrantyType: warranty?.warrantyType || "standard",
    provider: warranty?.provider || "",
    startDate: toInputDate(warranty?.startDate),
    endDate: toInputDate(warranty?.endDate),
    coverage: warranty?.coverage || "",
    contact: warranty?.contact || "",
    cost: warranty?.cost ?? "",
  });
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const submit = async () => {
    setBusy(true);
    setError(null);
    try {
      const data = new FormData();
      Object.entries(form).forEach(([k, v]) => data.append(k, v));
      if (file) data.append("file", file);
      const res = editing
        ? await api.patch(`/manufacturing/assets/warranties/${warranty.id}`, data)
        : await api.post(`/manufacturing/assets/machines/${machineId}/warranties`, data);
      onSaved(res.data.data);
    } catch (err) {
      setError(errorMessage(err, "Couldn't save the warranty."));
      setBusy(false);
    }
  };

  return (
    <AssetModal
      title={editing ? "Edit warranty" : "Add warranty / AMC"}
      busy={busy}
      error={error}
      onClose={onClose}
      onSubmit={submit}
      submitLabel={editing ? "Save changes" : "Add"}
    >
      <div className="am-row">
        <Field label="Type">
          <select className="am-select" value={form.warrantyType} onChange={set("warrantyType")}>
            {WARRANTY_TYPES.map((t) => <option key={t.value} value={t.value}>{t.label}</option>)}
          </select>
        </Field>
        <Field label="Provider *">
          <input className="am-input" value={form.provider} onChange={set("provider")} required maxLength={120} placeholder="Manufacturer or service company" />
        </Field>
      </div>
      <div className="am-row">
        <Field label="Starts *">
          <input className="am-input" type="date" value={form.startDate} onChange={set("startDate")} required />
        </Field>
        <Field label="Ends *">
          <input className="am-input" type="date" value={form.endDate} min={form.startDate || undefined} onChange={set("endDate")} required />
        </Field>
      </div>
      <Field label="What it covers">
        <textarea className="am-textarea" value={form.coverage} onChange={set("coverage")} maxLength={2000} placeholder="e.g. Parts and labour, excludes consumables and tooling" />
      </Field>
      <div className="am-row">
        <Field label="Claim contact">
          <input className="am-input" value={form.contact} onChange={set("contact")} maxLength={200} placeholder="Name, phone or email" />
        </Field>
        <Field label="Cost (₹)">
          <input className="am-input" type="number" min="0" step="0.01" value={form.cost} onChange={set("cost")} />
        </Field>
      </div>
      <Field label={editing && warranty.documentPath ? "Replace document" : "Warranty card / contract"} hint="JPG, PNG, WebP or PDF, up to 10 MB">
        <input className="am-input" type="file" accept="image/jpeg,image/png,image/webp,application/pdf" onChange={(e) => setFile(e.target.files[0] || null)} />
      </Field>
    </AssetModal>
  );
}
